import { Toast } from '@/utils/index';
import store from '@/store/index';
import { useNotice } from '@/utils/base/notice.js';
// websocket地址
var url = process.env.NODE_ENV === 'production' ? 'wss://visionhealthmed.com/websocket/' : 'ws://192.168.10.194:9008/websocket/';
// var url = process.env.NODE_ENV === 'production' ? 'wss://visionhealthmed.com/websocket/' : 'ws://visionhealthmed.com/websocket/';
// websocket实例
var ws;
// 重连定时器实例
var tt;
// websocket重连开关
var websocketswitch = false;

let time = null;

const BEAT_TIME = 1000 * 60 * 50; 

function setHeartBeat () {
    time = null;
    time = setTimeout(() => {
        ws.send('heartbeat');
        setHeartBeat()
    }, BEAT_TIME)
}

// websocket对象
var websocket = {
    // websocket建立连接
    Init(id) {
        if (process.env.NODE_ENV !== 'production') return;
        // 判断浏览器是否支持websocket
        if (!'WebSocket' in window) {
            Toast('warning', '您的浏览器不支持WebSocket', 3);
            return
        }
        // 创建websocket实例
        console.log(url + id, id);
        ws = new WebSocket(url + id)
        // 监听websocket连接
        ws.onopen = function () {
            // Toast('success', 'websocket连接成功', 3);
            setHeartBeat();
        }
        // 监听websocket连接错误信息
        ws.onerror = function (e) {
            console.log('重连开关', websocketswitch)
            console.log('数据传输发生错误', e)
            // Toast('warning', 'websocket传输发生错误', 3);
            // 打开重连
            reconnect()
        }
        ws.onclose = function (e) {
            // Toast('warning', 'websocket意外断开，正在重连中', 5);
            reconnect()
        }
        // 监听websocket接受消息
        ws.onmessage = function (e) {
            console.log(e, 'ws message');
            //心跳消息不做处理
            if (e.data === 'ok') {
                return
            }

            if (e.data === '发送成功') {
                // Toast('info', e.data, 3);
            } else if (!isNaN(Number(e.data))) {
                store.commit("SET_UNREADNUM", e.data);
                if (e.data > 0) {
                    Toast('info', '接收到新的消息通知', 3);
                }
            } else {
                const unReadNum = store.state.unReadNum;
                store.commit("SET_UNREADNUM", Number(unReadNum) + 1);
                useNotice((e.data));
            }
        }
    },
    // websocket连接关闭方法
    Close() {
        //关闭断开重连机制
        websocketswitch = true
        if (ws && ws.close) {
            reconnect()
            ws.close()
        }
    },
    // websocket发送信息方法
    Send(data) {
        if (ws.readyState !== 1) return 'fail';
        // 处理发送数据JSON字符串
        let msg = JSON.stringify(data)
        // 发送消息给后端
        ws.send(msg);
        return 'success';
    },
    // 暴露websocket实例
    getwebsocket() {
        return ws
    }
}

// 监听窗口关闭事件，当窗口关闭时-每一个页面关闭都会触发-扩张需求业务
window.onbeforeunload = function () {
    console.log('测试方法执行了')
}

// 重连方法
function reconnect() {
    const userInfo = localStorage.getItem('qc_userInfo');
    if (!userInfo) {
        return;
    }
    const { id } = JSON.parse(userInfo);
    // 判断是否主动关闭连接
    if (websocketswitch) {
        return
    }
    // 重连定时器-每次websocket错误方法onerror触发他都会触发
    tt && clearTimeout(tt)
    tt = setTimeout(function () {
        console.log('执行断线重连...')
        websocket.Init(id);
        websocketswitch = false
    }, 1000)
}

// 暴露对象
export default websocket